export const RETREAT_START = 'RETREAT_BUTTON/RETREAT_START';
export const RETREAT = 'RETREAT_BUTTON/RETREAT';
export const RETREAT_DONE = 'RETREAT_BUTTON/RETREAT_DONE';
/** Taking back a retreat in the moments before it's sent. */
export const RETREAT_UNDO = 'RETREAT_BUTTON/RETREAT_UNDO';

/** How long a retreat waits, with an Undo, before it's sent: retreating can't be taken back once it's made. */
export const UNDO_WINDOW_MS = 4000;

export const CHOOSE_BENCH_POSITION = 'RETREAT_BUTTON/CHOOSE_BENCH_POSITION';
